import {
	DefaultHeader,
	DefaultTitle,
	DefaultContent,
	DefaultFooter,
} from './default/elements';
import {
	WideHeader,
	WideTitle,
	WideContent,
	WideSidebar,
} from './wide/elements';
import {
	getDefaultDrawer,
	setDefaultDrawerRef,
	setWideDrawerRef,
	getWideDrawer,
} from './ref';
import DefaultDrawer from './default';
import WideDrawer from './wide';


const Drawer = {
	default: {
		Base:  DefaultDrawer,
		Header: DefaultHeader,
		Title: DefaultTitle,
		Content: DefaultContent,
		Footer: DefaultFooter,
		setRef: setDefaultDrawerRef,
		get: getDefaultDrawer as () => DefaultDrawer
	},
	wide: {
		Base:  WideDrawer,
		Header: WideHeader,
		Title: WideTitle,
		Content: WideContent,
		Sidebar: WideSidebar,
		setRef: setWideDrawerRef,
		get: getWideDrawer as () => WideDrawer
	}
}

export default Drawer;
